import Section from "../Section";
import Swiper from 'swiper/bundle';

export default class InfoColumns extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.slidesPerView = parseInt(this.element.dataset.slidesPerRow);
    this.swiperContainer = this.element.querySelector('.swiper');
    this.numberOfSlides = parseInt((/** @type {HTMLElement} */ (this.swiperContainer)).dataset.numberOfSlides, 10);
    const nextEl = this.element.querySelector('.swiper-button--next');
    const prevEl = this.element.querySelector('.swiper-button--prev');
    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: 1,
      allowTouchMove: true,
      navigation: {
        nextEl,
        prevEl,
      },
      breakpoints: {
        // when window width is >= 768px
        769: {
          slidesPerView: this.slidesPerView,
        },
      },
      watchOverflow: true,
      autoHeight: true,
      pagination: {
        el: this.swiperContainer.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  }

  onBlockSelect = ({ element }) => {
    const index = parseInt(element.dataset.swiperSlideIndex, 10);
    const transitionDuration = 300; // Transition duration (ms) – 300 is the default value
    this.swiper.slideTo(index, transitionDuration, false)
  }
}
